import {
  About1,
  About2,
  About3,
  About4,
  About5,
  About6,
  About7,
} from './components';

const ImageContainers = () => {
  return (
    <div
      style={{
        backgroundColor: 'rgba(16,18,18)',
      }}
    >
      <About1 />
      <About2 />
      <About3 />
      <About4 />
      <About5 />
      <About6 />
      <About7 />
    </div>
  );
};
export default ImageContainers;
